import React from 'react';
import { Home, Service, Contact, Testimonial, Product } from './components';
const Main = () => {
  return (
    <>
      <Home />
      <Product />
      <Service />
      <Testimonial />
      <Contact />
    </>
  );
};

export default Main;
